import {createStore} from 'vuex';
import {getProducts} from '@api/products';
import moment from 'moment';

require('moment-weekday-calc');

const store = createStore({
    state() {
        return {
            searchTownItems: [],
            searchStreetItems: [],
            formErrors: [],
            fieldDeps: {
                town: {
                    parent_id: null,
                    child: 'street'
                },
                street: {
                    parent_id: null,
                    child: null,
                },
            },
            isLoading: false,
            config: {},
            products: [],
            reviews: [],
            form: {
                name: null,
                surname: null,
                patronymic: null,
                town: null,
                townLabel: null,
                street: null,
                streetLabel: null,
                house: null,
                pav: null,
                door_num: null,
                apart: null,
                index: null,
                phone: null,
                ex_date: null,
                byType: 0,
                date: null,
                time: null
            },
            formAttrs: {
                town: {
                    title: 'Населённый пункт',
                    placeholder: null,
                    description: null
                },
                street: {
                    title: 'Улица',
                    placeholder: null,
                    description: null
                },
                name: {
                    title: 'Имя',
                    placeholder: 'Введите имя',
                    description: null
                },
                surname: {
                    title: 'Фамилия',
                    placeholder: 'Введите фамилию',
                    description: null
                },
                patronymic: {
                    title: 'Отчество',
                    placeholder: 'Введите отчество',
                    description: null
                },
                house: {
                    title: 'Дом',
                    placeholder: 'Номер дома',
                    description: null
                },
                pav: {
                    title: 'Корпус',
                    placeholder: 'Номер корп.',
                    description: 'Если корпуса нет, оставьте поле пустым'
                },
                door_num: {
                    title: 'Номер подъезда',
                    placeholder: 'Номер подъезда',
                    description: 'Если подъезд в доме всего один, оставьте поле пустым'
                },
                apart: {
                    title: 'Квартира',
                    placeholder: 'Номер квартиры',
                    description: null
                },
                index: {
                    title: 'Индекс',
                    placeholder: 'Введите индекс',
                    description: 'Почтовый индекс состоит из 6 цифр. Чтобы узнать свой индекс, перейдите по <a href="https://belpost.by/Uznatpochtovyykod28indek" target="_blank">ссылке</a>.'
                },
                phone: {
                    title: 'Телефон',
                    placeholder: '29 1234567',
                    description: null
                },
                ex_date: {
                    title: 'Дата первого экзамена',
                    placeholder: null,
                    description: null
                },
            },
        };
    },
    getters: {
        products: state => state.products,
        reviews: state => state.reviews,
        isLoading: state => state.isLoading,
        form: state => state.form,
        formErrors: state => state.formErrors,
        formAttrs: state => state.formAttrs,
        fieldDeps: state => state.fieldDeps,
        config: state => state.config,
        searchTownItems: state => state.searchTownItems,
        searchStreetItems: state => state.searchStreetItems,
        estimatedDeliveryDate() {
            const nowHours = Number(new Date().getHours());

            const deliveryDelay = 1;
            let packedDelay = 1;

            if (nowHours >= 12) {
                packedDelay++;
            }

            const dateNow = Date.now();

            let date_start = new Date(dateNow + (packedDelay + deliveryDelay) * 60 * 60 * 24 * 1000);

            const holidays = moment().isoWeekdayCalc(date_start, [7]);
            date_start = new Date(dateNow + (packedDelay + deliveryDelay + holidays) * 60 * 60 * 24 * 1000);

            let day_start = String(date_start.getDate());

            let month_start = String(date_start.getMonth() + 1);

            const monthLabels = {
                1: 'января',
                2: 'февраля',
                3: 'марта',
                4: 'апреля',
                5: 'мая',
                6: 'июня',
                7: 'июля',
                8: 'августа',
                9: 'сентября',
                10: 'октября',
                11: 'ноября',
                12: 'декабря',
            };

            day_start = 5;
            month_start = 7;

            return '';

            // return `${day_start} ${monthLabels[month_start]}`;
        },
    },
    mutations: {
        setSearchItems(state, payload) {
            const type = payload.type[0].toUpperCase() + payload.type.slice(1);
            state[`search${type}Items`] = payload.items;
        },
        setState(state, payload) {
            Object.assign(state, {...payload});
        },
        updateForm(state, payload) {
            Object.assign(state.form, {...payload});
        },
        setTown(state, town) {
            state.form.town = town;
            state.form.townLabel = `${town.type.short_name} ${town.name}`;
            state.fieldDeps[state.fieldDeps.town.child].parent_id = town.id;
            state.form.street = null;
            state.form.streetLabel = null;
            state.searchTownItems = [];
            state.searchStreetItems = [];
        },
        setFormErrors(state, errors) {
            state.formErrors = errors;
        },
        setStreet(state, street) {
            state.form.street = street;
            state.form.streetLabel = `${street.type.short_name} ${street.name}`;
            state.searchStreetItems = [];
            state.searchTownItems = [];
        },
        isLoadingStart(state) {
            state.isLoading = true;
        },
        isLoadingEnd(state) {
            state.isLoading = false;
        },
        setByType(state, value) {
            state.form.byType = value;
        },
    },
    actions: {
        loadData({commit}) {
            commit('isLoadingStart');
            getProducts().then(response => {
                commit('setState', response);
                commit('isLoadingEnd');
            });
        },
        loadAddress({commit}, payload) {
            const pId = payload.value;

            axios.get(`/market/api/${payload.type}`, {
                params: {
                    parent_id: pId
                }
            })
                .then(response => {
                    commit('setState', {[payload.type]: response.data});
                });
        },
    }
});

export default store;
